import ICommand from '../../../FrontApplet/Command/ICommand';
import { ITypedCommandEvent } from '../../../FrontApplet/Command/ICommandEvent';
import FrontApplet from '../../../FrontApplet/FrontApplet';
import {
	ManagementDebugDisableRequest,
	ManagementDebugDisableResult,
	ManagementDebugEnableRequest,
	ManagementDebugEnableResult,
	ManagementDebugIsEnabledRequest,
	ManagementDebugIsEnabledResult,
	ManagementDebugRequests,
} from './debugCommands';

export function handleManagementDebugRequests(
	onCommand: (callback: (commandEvent: ITypedCommandEvent<ManagementDebugRequests>) => Promise<void>) => void,
	dispatch: <TCommand extends ICommand>(command: TCommand) => Promise<void>,
	frontApplet: FrontApplet,
) {
	onCommand(async (commandEvent: ITypedCommandEvent<ManagementDebugRequests>) => {
		switch (commandEvent.command.type) {
			case ManagementDebugEnableRequest:
				await frontApplet.management.debug.enable();
				await dispatch<ManagementDebugEnableResult>({
					type: ManagementDebugEnableResult,
					result: {},
				});
				break;
			case ManagementDebugDisableRequest:
				await frontApplet.management.debug.disable();
				await dispatch<ManagementDebugDisableResult>({
					type: ManagementDebugDisableResult,
					result: {},
				});
				break;
			case ManagementDebugIsEnabledRequest:
				await dispatch<ManagementDebugIsEnabledResult>({
					type: ManagementDebugIsEnabledResult,
					result: await frontApplet.management.debug.isEnabled(),
				});
				break;
			default:
		}
	});
}
